/**
 * API surface for the vendor portal.
 * Upload uses Document API presign (see presignUpload.js).
 */
import api from './httpClient';

export {
  uploadFileViaPresign as uploadFile,
  resolveFileViewUrl as getFileUrl,
  openUploadedFile,
} from './presignUpload';

// Auth
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  me: () => api.get('/auth/me'),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  getResetPasswordAccount: (token) =>
    api.get('/auth/reset-password', { params: { token } }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

// Vendor
export const vendorAPI = {
  getApplication: () => api.get('/vendor/application'),
  saveApplication: (data) => api.post('/vendor/application', data),
  submitApplication: () => api.post('/vendor/application/submit'),
  getQueries: () => api.get('/vendor/queries'),
  respondToQuery: (queryId, data) => api.post(`/vendor/queries/${queryId}/respond`, data),
};

// Admin
export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  getApplications: (params) => api.get('/admin/applications', { params }),
  getApplicationDetail: (id) => api.get(`/admin/applications/${id}`),
  approveApplication: (id, data) => api.post(`/admin/applications/${id}/approve`, data),
  rejectApplication: (id, data) => api.post(`/admin/applications/${id}/reject`, data),
  raiseQuery: (id, data) => api.post(`/admin/applications/${id}/query`, data),
  addRemark: (id, data) => api.post(`/admin/applications/${id}/remark`, data),
  startReview: (id) => api.post(`/admin/applications/${id}/start-review`),
  forwardToAR: (id, data = {}) => api.post(`/admin/applications/${id}/forward-to-ar`, data),
  forwardToHoS: (id, data = {}) => api.post(`/admin/applications/${id}/forward-to-hos`, data),
  returnToDA: (id, data) => api.post(`/admin/applications/${id}/return-to-da`, data),
  getAuditLogs: (id) => api.get(`/admin/audit-logs/${id}`),
  downloadScrutinyReport: (id) =>
    api.get(`/admin/applications/${id}/scrutiny-report`, { responseType: 'blob' }),
  getUsers: ({ page = 1, page_size = 10, role } = {}) =>
    api.get('/admin/users', {
      params: { page, page_size, ...(role ? { role } : {}) },
    }),
  createUser: (data) => api.post('/admin/users', data),
};

// RFQ
export const rfqAPI = {
  getRFQs: (status) => api.get('/rfq', { params: { status } }),
  getRFQDetail: (id) => api.get(`/rfq/${id}`),
  createRFQ: (data) => api.post('/rfq', data),
  closeRFQ: (id) => api.post(`/rfq/${id}/close`),
};

// Quotations
export const quotationAPI = {
  getMyQuotations: () => api.get('/quotation'),
  submitQuotation: (data) => api.post('/quotation', data),
  acceptQuotation: (id) => api.post(`/quotation/${id}/accept`),
};

// Purchase Orders
export const poAPI = {
  getPOs: (status) => api.get('/po', { params: { status } }),
  getPODetail: (id) => api.get(`/po/${id}`),
  createPO: (data) => api.post('/po', data),
  acknowledgePO: (id, data) => api.post(`/po/${id}/acknowledge`, data),
  updateDelivery: (id, data) => api.post(`/po/${id}/delivery`, data),
  updatePayment: (id, data) => api.post(`/po/${id}/payment`, data),
};

// Invoices
export const invoiceAPI = {
  getInvoices: (status) => api.get('/invoice', { params: { status } }),
  submitInvoice: (data) => api.post('/invoice', data),
  verifyInvoice: (id) => api.post(`/invoice/${id}/verify`),
  updatePayment: (id, status, reference) =>
    api.post(`/invoice/${id}/payment`, null, {
      params: { payment_status: status, payment_reference: reference },
    }),
};

export default api;
